<template>
  <div class="bg-white rounded-sm mx-3 my-3">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mt-3">
        <div class="grid grid-cols-12 gap-4 mx-1">
          <div class="col-span-11">
            <span class="title mx-1">Legal Document</span>
          </div>
          <div class="col-span-1 mx-auto text-center">
            <button class="btn-primary w-full bg-primary rounded px-2 py-1 text-white hover:bg-primary-dark" @click="back">
              <i class="fa fa-arrow-left text-white mr-2"></i>Back
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-4 mx-3 mt-2">
      <div class="col-span-12 mx-auto bg-gray-10 py-3 rounded">
        <span class="text-gray">Document / {{ instrumentNumber }} / {{ cleanDocumentType(document.documentType.toUpperCase()) }}</span>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-4 mx-3 mt-2">
      <div class="col-span-12">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12 mt-2">
            <span class="font-bold text-gray h4">{{ document.subjectMatter }}</span><br/>
            <div class="flex my-1">
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize">
                {{ cleanDocumentType(document.documentType.toLowerCase()) }}
              </span>
            </div>
            <span class="text-gray text-xs font-bold">Registration Date: {{ dateFormat(document.filingDate) }}</span><br/>
          </div>
        </div>

        <div class="grid grid-cols-12 gap-4 pt-1">
          <div class="col-span-12">
            <div class="border-b border-gray-200">
              <nav class="flex space-x-6 px-4" aria-label="Tabs">
                <div :class="[(currentRoute === 'details') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('details')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Details</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'attachment') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('attachment')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Attachment</div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-12 gap-4 py-4">
          <div class="col-span-12">
            <LegalDocumentDetails :document="document" v-if="currentRoute === 'details'"/>
            <LegalDocumentRegistryAttachment :document-handle="document.edmsId" v-if="currentRoute === 'attachment'"/>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useLegalDocumentsRegistryStore } from "@/stores/legal-documents-registry";
import { dateFormat } from "@/commons/composables/utilities";
import LegalDocumentRegistryAttachment
  from "@/domains/home/services/registry/legal-documents/tabs/LegalDocumentRegistryAttachment.vue";
import LegalDocumentDetails from "@/domains/home/services/registry/legal-documents/tabs/LegalDocumentDetails.vue";
import { LegalDocument } from "@/domains/home/services/registry/legal-documents/types";

const route = useRoute()
const store = useLegalDocumentsRegistryStore();

const instrumentNumber = ref<string | null>(null)
const loading = ref(false)
const document = ref<LegalDocument>({} as LegalDocument);
const currentRoute = ref("details")

onMounted(() => {
  instrumentNumber.value = route.params.id as string
  store.fetchLegalDocumentDetails(instrumentNumber.value);
})

const select = (selectedRoute: string) => {
  currentRoute.value = selectedRoute
}

const cleanDocumentType = (name: string) => {
  let n = name.replaceAll("_", " ")
  return n.charAt(0).toUpperCase() + n.slice(1)
}

const back = () => {
  window.history.back()
}

watch(() => store.document_details, (data) => {
  if (data) {
    document.value = data
  }
})
</script>
